export default __webpack_public_path__ + "static/strektykkelse-detaljniva-eksempel2-9f7242e3eb91b959ea9e244d13bb85b6.png";